import * as React from 'react'

const FormLayout = ({ children }) => {
  return (
    <div className="tw-flex tw-flex-1 sm:tw-min-w-[400px] tw-flex-col tw-gap-4">{children}</div>
  )
}

export default FormLayout
